import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { associateMetaSiteIds, createRecipient, deleteRecipient, getOrCreateRecipient, getRecipient, queryRecipients, updateRecipient } from './generated/RecipientClient/recipientHttpRequests';
import { RecipientClientBase } from './RecipientClientBase';
export class RecipientClient extends HttpBaseClient(RecipientClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "getRecipientImpl", getRecipient);
    _defineProperty(this, "queryRecipientsImpl", queryRecipients);
    _defineProperty(this, "createRecipientImpl", createRecipient);
    _defineProperty(this, "getOrCreateRecipientImpl", getOrCreateRecipient);
    _defineProperty(this, "associateMetaSiteIdsImpl", associateMetaSiteIds);
    _defineProperty(this, "updateRecipientImpl", updateRecipient);
    _defineProperty(this, "deleteRecipientImpl", deleteRecipient);
  }
}
//# sourceMappingURL=RecipientClientHttp.js.map